<template>
  <TableLayout :permissions="['business:rentsite:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编号" prop="code">
        <el-input v-model="searchForm.code" placeholder="请输入编号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:rentsite:create']">
        <li><el-button type="primary" @click="$refs.operaRentSiteWindow.open('新建租车点')" icon="el-icon-plus" v-permissions="['business:rentsite:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="code" label="租车点编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="name" label="租车点名称" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="longitude" label="经纬度" min-width="100px" align="center">
          <template slot-scope="{row}">
            {{ `${row.latitude}，${row.longitude}`}}
          </template>
        </el-table-column>
        <el-table-column prop="addr" label="地址" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px" align="center"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:rentsite:update', 'business:rentsite:delete'])"
          label="操作"
          min-width="120"
          align="center"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaRentSiteWindow.open('编辑租车点', row)" icon="el-icon-edit" v-permissions="['business:rentsite:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:rentsite:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaRentSiteWindow ref="operaRentSiteWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRentSiteWindow from '@/components/business/OperaRentSiteWindow'
export default {
  name: 'RentSite',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRentSiteWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        code: '',
        longitude: '',
        latitude: '',
        status: '',
        addr: '',
        info: ''
      }
    }
  },
  created () {
    this.config({
      module: '租车点信息表',
      api: '/business/rentSite',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
